/* 🤖 this file was generated by svg-to-ts */
export const matIconViewCozy: {
  name: 'view-cozy';
  data: string;
} = {
  name: 'view-cozy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.25 7.25h4v4h-4zm5.5 0h4v4h-4zm-5.5 5.5h4v4h-4zm5.5 0h4v4h-4z"/><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"/></svg>`
};
